<div class="card mb-5">
    <div class="card-header">
        <h3>
            Órdenes Activas
            <a
                routerLink="/sales/invoice"
                class="clickeable"
                style="text-decoration: none"
            >
                <!-- <span class="sp-con-default">
                    <i class="fa-solid fa-circle-plus"></i>
                    <i
                        style="color: var(--bs-bg-servicios)"
                        class="bx bx-detail sp-el-default"
                    ></i>
                </span> -->
            </a>
        </h3>
    </div>
    <div class="card-body">
        <div class="row" id="options-other-filters">
            <div class="col-sm form-group">
                <label for="filterVendors" class="form-label">Filtrar</label>
                <div class="input-group input-group-sm">
                    <input
                        type="text"
                        id="filter"
                        [(ngModel)]="filterWord"
                        (input)="onInputChange($event)"
                        placeholder="Filtra pedidos por usuario o bodega"
                        name="filter"
                        class="form-control"
                    />
                    <button class="btn btn-primary" (click)="searching()">
                        <i class="fa fa-search"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="table-responsive" style="margin-bottom: 0">
            <table
                class="table table-bordered"
                style="margin-bottom: 0; margin-top: 1em"
            >
                <thead>
                    <tr>
                        <th class="ta">Número</th>
                        <th class="text-center">Fecha Solicitado</th>
                        <th class="text-center">Fecha Esperada</th>
                        <th class="ta">Proveedor</th>
                        <th class="ta">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let order of pagination.filter">
                        <tr>
                            <td>{{ order.number }}</td>
                            <td class="text-center">
                                {{
                                    formatDate(order.creationDate)
                                        | date : "dd/MM/yyyy"
                                }}
                            </td>
                            <td
                                class="d-flex justify-center items-center"
                                style="max-width: 120px; min-width: 100%"
                            >
                                <div *ngIf="editingItem !== order.number">
                                    <span
                                        (click)="startEditing(order.number)"
                                        class="profit-ammount"
                                    >
                                        {{
                                            formatDate(order.deliveryDate)
                                                | date : "dd/MM/yyyy"
                                        }}
                                        <i class="fa fa-edit span-hover"></i>
                                    </span>
                                </div>

                                <div
                                    *ngIf="editingItem === order.number"
                                    class="input-group input-group-sm"
                                >
                                    <input
                                        #newQty
                                        type="date"
                                        name="profit"
                                        [value]="order.deliveryDate"
                                        style="text-align: center"
                                        id="profit"
                                        class="form-control"
                                        min="0"
                                        step="0.01"
                                    />
                                    <button
                                        class="btn btn-success"
                                        [disabled]="loading[order.number]"
                                        (click)="
                                            saveDeliveryDate(
                                                order,
                                                newQty.value
                                            )
                                        "
                                    >
                                        <ng-container
                                            *ngIf="!loading[order.number]"
                                        >
                                            <i class="fa fa-floppy-disk"></i>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="loading[order.number]"
                                        >
                                            <span
                                                class="spinner-border spinner-border-sm"
                                                aria-hidden="true"
                                            ></span>
                                            <span role="status"></span>
                                        </ng-container>
                                    </button>
                                </div>
                            </td>
                            <td>
                                {{
                                    order.providerData
                                        ? order.providerData.name
                                        : "Desconocido"
                                }}
                            </td>
                            <!-- <td>
                        <div class="order-div">
                            <input id="order" name="order" type="checkbox"  
                            (change)="disableOrder(order)"
                            [(ngModel)]="order.active" 
                            >
                            <label class="button" for="order">
                                <div class="dot"></div>
                            </label>
                            <div [class.checked-text]="order.active">{{ order.active ? 'Sí' : 'No'}}</div>
                        </div>
                    </td> -->
                            <td class="d-flex justify-center items-center gap-1">
                                <span
                                    (click)="showDetails(order.id)"
                                    class="a-hover"
                                    tooltip="Ver Detalles"
                                >
                                    <i
                                        class="fa fa-eye span-hover text-primary"
                                    ></i>
                                </span>
                                <span (click)="downloadOrder(order)" class="download-receipt" tooltip="Descargar">
                                    <i class="clickeable text-info fa fa-receipt span-hover text-primary"></i>
                                </span>
                                    <div
                                        class="container-superposition"
                                        title="Eliminar"
                                        tooltip="Eliminar"
                                    >
                                        <div
                                            class="element-superposition"
                                            *ngIf="waitingFor?.id == order.id"
                                        >
                                            <span
                                                >¿Está seguro que desea Eliminar
                                                esta orden?</span
                                            >
                                            <span class="a-container">
                                                <span class="a-hover" (click)="resetDeletingDiv()"
                                                    ><i class="fa fa-ban"></i
                                                    >NO</span
                                                >
                                                <span class="a-hover text-danger" (click)="confirmDelete(order)">
                                                    <i class="fa fa-check"></i>
                                                    SÍ
                                                </span>
                                            </span>
                                        </div>
                                        <span
                                            class="clickeable text-danger span-hover"
                                            (click)="deleteOrder(order)"
                                        >
                                            <i
                                                *ngIf="!deleting[order.id]"
                                                class="fa fa-xmark-circle"
                                            ></i>
                                            <span
                                                *ngIf="deleting[order.id]"
                                                class="spinner-border spinner-border-sm"
                                                aria-hidden="true"
                                            ></span>
                                        </span>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="pagination.filter.length == 0">
                            <td colspan="9" class="ta" style="color: gray">
                                <i class="fa fa-circle-info"></i>No se tienen
                                pedidos
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <app-pagination-custom [elements]="pagination"></app-pagination-custom>
    </div>
</div>

<app-modal-purchase-order-detail
    *ngIf="viewDetials != null"
    [orderId]="viewDetials"
    [order]="viewOrder"
    (close)="closeCreateOrder($event)"
    (updateCurrency)="updateCurrency($event)"
></app-modal-purchase-order-detail>
